var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.489 18.573l-3.808-3.96a6.44 6.44 0 0 0 1.515-4.153A6.467 6.467 0 0 0 10.736 4a6.467 6.467 0 0 0-6.46 6.46 6.467 6.467 0 0 0 6.46 6.46 6.39 6.39 0 0 0 3.701-1.169l3.837 3.99c.16.167.376.259.608.259a.844.844 0 0 0 .607-1.427zM10.736 5.685a4.78 4.78 0 0 1 4.775 4.775 4.78 4.78 0 0 1-4.775 4.775 4.78 4.78 0 0 1-4.774-4.775 4.78 4.78 0 0 1 4.774-4.775z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/Icons_Search.cac0e2747c980248a0dd754729a8a3b0.svg";
export { ForwardRef as ReactComponent };